import { render } from "./AppMenuItem.vue?vue&type=template&id=4e3a843a"
import script from "./AppMenuItem.vue?vue&type=script&lang=js"
export * from "./AppMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__